import React from "react";
import "./LoadingAnimation.css";

export default function LoadingAnimation() {
  return (
    <div >
      <div
        className="flex flex-col p-2 md:mx-2 mb-5 rounded-xl bg-white shadow-xl md:bg-transparent md:shadow-none glass"
        style={{padding:'1.5rem'}}
      >
        <div className="flex flex-col mb-2">
          <div className="flex flex-col gap-2 justify-start">
            <div className="dmy-top">
                <div className="dmy-img"></div>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'flex-start',width:'8rem',margin:'0 0.3rem'}}>
                    <h3 className="dmy-txt"></h3>
                    <p className="dmy-txt" style={{width:'80%',height:'0.7rem'}}></p>
                </div>
            </div>
            <div className="dmy-desc"></div>
            <div className="dmy-desc"></div>
            <div className="dmy-desc"></div>
            <div className="dmy-desc"></div>
            <div className="dmy-desc"></div>
          </div>
        </div>
      </div>     
    </div>
  );
}
